<template>
  <div class="community-news-content p-10">
    <div class="ly-card search-content">
      <div class="btn-group">
        <el-button type="primary" @click.native="() => edit()">添加</el-button>
      </div>
      <div class="search-group">
        <div class="inline-block">
          <remote-search ref="news_category_id" :options="news_category_id" @input="changeCategory" />
        </div>
        <el-select clearable  v-model="searchFormData.activate_status" placeholder="请选择状态">
          <el-option label="全部" :value="-1"> </el-option>
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-input placeholder="关键词" v-model.trim="searchFormData.query" @keypress.enter.native="search" />
        <el-button type="primary" @click="search">查询</el-button>
      </div>
    </div>
    <div class="ly-card">
      <ly-table class='news-table'  :getTableData="getTableData" :tableHeader="tableHeader" :searchFormData="searchFormData" ref="lyTable">
        <template v-slot:content_title="row">
          <el-button @click="detail(row)" type="text" size="mini">
            <img :src="`${baseUrl}/${row.content_url}`" height="30px" style="vertical-align: text-bottom;" />
            <em>{{ row.content_title }}</em>
          </el-button>
        </template>
        <template v-slot:action="row">
          <el-button @click="edit(row)" type="text" size="mini">修改</el-button>
          <el-button @click="revoke(row)" type="text" v-if="row.activate_status" class="el-button--danger" size="mini"
            >禁用</el-button
          >
          <el-button v-else @click="publish(row)" type="text" size="mini">启用</el-button>
          <el-button @click="del(row)" type="text" class="el-button--danger" size="mini">删除</el-button>
        </template>
      </ly-table>
    </div>
    <el-dialog :title="curRow.content_title" :visible.sync="visible" width="800px">
      <div v-html="curRow.content"></div>
    </el-dialog>
  </div>
</template>

<script>
import { Input, Dialog, Select, Option } from 'element-ui';
import cNews from '@/api/cNews';
import LyTable from '@/components/LyTable';
import { newsContentTable } from '@/utils/tableHeader';
import localCache from '@/utils/localCache';
import { news_category_id } from '@/utils/formConfigCommon';
import RemoteSearch from '@/components/common/RemoteSearch';

export default {
  name: 'CommunityNewsContent',
  components: {
    LyTable,
    RemoteSearch,
    ElInput: Input,
    ElDialog: Dialog,
    ElSelect: Select,
    ElOption: Option
  },
  data() {
    return {
      searchFormData: {
        query: '',
        activate_status: ''
      },
      tableHeader: newsContentTable,
      getTableData: cNews.getNewsContent,
      baseUrl: '',
      curRow: {},
      visible: false,
      statusList: [],
      news_category_id: {
        ...news_category_id.options,
        key: 'news_category_id',
        staticResult: [{ label: '全部', value: -1 }],
        rules: [
          {
            required: false,
            message: '请选择类型名称',
            trigger: 'change'
          }
        ]
      }
    };
  },
  async mounted() {
    this.baseUrl = await this.$store.dispatch('app/getOssUrl');
    this.init();
    cNews.activateStatus().then(res => {
      if (res && res.data) {
        this.statusList = res.data.list;
      }
    });
  },
  activated() {
    this.init();
  },
  methods: {
    async init() {
      this.search();
    },
    changeCategory(value) {
      this.searchFormData.news_category_id = value;
    },
    search() {
      this.$refs.lyTable.setData();
    },
    edit(row) {
      localCache.setItem('newsContentInfo', row);
      this.$router.push(`/${this.$route.params.user_id}/community/newsContent/${row ? row.id : -1}`);
    },
    del(row) {
      this.$confirm('永久删除该资讯, 是否继续?', '警告', {
        type: 'warning'
      })
        .then(() => {
          cNews
            .updateNewsContent({
              news_content_id: row.id,
              methold: 'DELETE'
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    publish(row) {
      this.$confirm('启用该资讯, 是否继续?', '警告', {
        type: 'warning'
      })
        .then(() => {
          cNews
            .batchActivateNewsContent({
              news_content_ids: [row.id]
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '启用成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    revoke(row) {
      this.$confirm('禁用该资讯, 是否继续?', '警告', {
        type: 'warning'
      })
        .then(() => {
          cNews
            .batchDeactivateNewsContent({
              news_content_ids: [row.id]
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '禁用成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    async addSubmit() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (!valid) return;
      if (this.defaultFormItem.id) {
        // 修改
        const res = await cNews.updateNewsContent({
          news_content_id: this.defaultFormItem.id,
          params: data,
          methold: 'put'
        });
        if (res) {
          this.$message.success(res.msg || '修改成功！');
        }
      } else {
        // 新增
        const res = await cNews.addNewsContent({
          params: data
        });
        if (res) {
          this.$message.success(res.msg || '新增成功！');
        }
      }
      this.search();
      this.dialogVisible = false;
    },
    close() {
      if (this.$refs.lyForm) this.$refs.lyForm.resetFields();
    },
    detail(row) {
      localCache.setItem('newsContentDetail', row);
      this.$router.push(`/${this.$route.params.user_id}/community/newsContentDetail/${row ? row.id : -1}`);
      // this.curRow = row;
      // this.visible = true;
    }
  }
};
</script>

<style lang="less">
.community-news-content {
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 150px;
      margin-right: 20px;
    }
  }
  .field-label .el-checkbox {
    min-width: 100px;
    margin-bottom: 15px;
  }
  .one-line {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .news-table{
    .el-button{
      span{
        display: flex;
        align-items: center;
        em{
          margin-left:5px;
          font-style:normal
        }
        // img{
        //   max-width:45px;
        //   max-height:30px;
        // }
      }
    }
  }
}
.an-form {
  .el-input__inner,
  .el-textarea__inner {
    width: 250px;
  }
  .el-input {
    width: auto;
  }
}
</style>
